import { connect } from 'react-redux';

import { GalleryLayout, IGalleryLayoutStateProps } from '../../components/mobile/GalleryLayout';
import { getSlides } from '../../selectors/fotorama';
import { IState } from '../../store';

export function mapStateToProps(state: IState): IGalleryLayoutStateProps {
  return {
    slides: getSlides(state),
    isFat: state.isFatCard,
  };
}

export const GalleryLayoutContainer = connect(mapStateToProps)(GalleryLayout);
